<template>
  <div class="compressed-content">
    <h3 class="page-question">How many packs a day do you smoke? How many years have you been smoking?</h3>
    <div class="page-buttons">
      <v-form-group :validator="$v.packsPerDayCurrently" label="Packs per day">
        <form-select slot-scope="{ attrs, listeners }"
                     v-bind="attrs"
                     v-on="listeners"
                     :options="smokingPacks" 
                     v-model="survey.smoking.packsPerDayCurrently" 
                     @input="survey.smoking.packsPerDayCurrently = $event.value"
                     placeholder="Packs per day" />
      </v-form-group>
      <v-form-group :validator="$v.yearsSmokingCurrently" label="Years smoking">
        <b-form-input slot-scope="{ attrs, listeners }"
                      v-bind="attrs"
                      v-on="listeners"
                      v-model="survey.smoking.yearsSmokingCurrently"
                      placeholder="Years smoking" />
      </v-form-group>
    </div>
  </div>
</template>

<script>
  import formMixin from "mixins/form-mixin";
  import { required, between, numeric, decimal } from "vuelidate/lib/validators";
  import { createNamespacedHelpers } from 'vuex';

  import { smokingPacks } from '@/constants';

  const { mapState } = createNamespacedHelpers('survey');

  export default {
    mixins: [formMixin],

    data() {
      return {
        smokingPacks,
      }
    },

    validations: {
      packsPerDayCurrently: {
        required,
        between: between(0.5, 5),
        decimal
      },
      yearsSmokingCurrently: {
        required,
        between: between(1, 80),
        numeric
      }
    },

    computed: {
      ...mapState(["survey"]),

      packsPerDayCurrently() { return this.survey.smoking.packsPerDayCurrently; },
      yearsSmokingCurrently() { return this.survey.smoking.yearsSmokingCurrently; }
    }
  };
</script>
